<template>
<div class="landingPageWrapper">
  <portal to="root">
    <navigation-bar />
  </portal>

  <div
    v-for="(part, index) in parts"
    :key="index"
    >
    <fixed-image
      v-if="part.type === 'fixed-image'"
      :title="part.title"
      :copy="part.copy"
      :app-link="part.appLink === true"
      :image-url="part.imageUrl"
      :right-align="part.rightAlign === true"
      :light-text="part.lightText === true"
      :scroll-image="part.scrollImage === true"
      :left-align-image="part.leftAlignImage === true"
      :right-align-image="part.rightAlignImage === true"
      :signup="part.signup === true"
      :device-image="part.deviceImage === true"
      :banner="part.banner || ''"
      />
    <customer-quote
      v-if="part.type === 'customer-quote'"
      :quote="part.quote"
      :name="part.name"
      />
    <video-slide
      v-if="part.type === 'video-slide'"
      />
  </div>

  <partner-slide />

  <info-footer />

  <subscribe-modal />
</div>
</template>
<script>

import PartnerSlide from '@/components/landingPage/PartnerSlide.vue'
import NavigationBar from '@/components/NavigationBar.vue'
import CustomerQuote from '@/components/landingPage/CustomerQuote.vue'
import FixedImage from '@/components/landingPage/FixedImage.vue'
import SubscribeModal from '@/components/landingPage/SubscribeModal.vue'
import VideoSlide from '@/components/landingPage/VideoSlide.vue'
import InfoFooter from '@/components/landingPage/InfoFooter.vue'

export default {
  name: 'HomePage',
  components: { NavigationBar, FixedImage, CustomerQuote, PartnerSlide, SubscribeModal, VideoSlide, InfoFooter },
  data () {
    return {
      parts: [{
        title: this.__('Look up!<br>Feel the difference.'),
        copy: this.__('New unique innovation for riders. A wearable that helps you improve your seat quickly which results in more effective training and less strain on the horse. Learning made easy.'),
        // imageUrl: require('@/assets/hero_color.jpg'),
        imageUrl: require('@/assets/hero_banner_medium.jpg'),
        lightText: true,
        deviceImage: true,
        type: 'fixed-image'
      },
      {
        type: 'customer-quote',
        quote: this.__('A genius product, that will make a huge difference, not at least for the horses.'),
        name: this.__('Pether Markne, top trainer and well-known profile')
      },
      {
        type: 'video-slide'
      },
      {
        type: 'customer-quote',
        quote: this.__('I need one of these. Everyone I know needs one of these.'),
        name: this.__('Ólafur, professional rider and trainer')
      },
      {
        title: this.__('RideQ makes it easy'),
        copy: this.__('Are you aware of in what situations, and how often, you look down at your hands or the horse when you are riding?<br><br>Do you know how much this affects your seat? We know, and it is more than you think!<br><br>Our personal movement patterns are hard to change. RideQ helps you!'),
        imageUrl: require('@/assets/angle.jpg'),
        rightAlign: true,
        scrollImage: true,
        leftAlignImage: true,
        type: 'fixed-image'
      },
      {
        type: 'customer-quote',
        quote: this.__('Very easy to use. Works great for us!'),
        name: this.__('Carl Hedin, dressage rider, influencer')
      },
      {
        title: this.__('How RideQ work'),
        copy: this.__('HeadQ reads your position. When you tilt your head forward you will be reminded, with a gentle buzz, to look up. The buzz feels very similar to a notification signal from a cell phone. Because of the smart placement of the signal you will react automatically to the feedback, and not have to figure out what to do. This ensures that you can complete the task you are working on and not have to shift focus.'),
        imageUrl: require('@/assets/device.jpg'),
        rightAlignImage: false,
        type: 'fixed-image'
      }, {
        type: 'customer-quote',
        quote: this.__('All of a sudden, everything felt so easy.'),
        name: this.__('Johanna Peterson')
      }, {
        title: this.__('You personalize your HeadQ'),
        copy: this.__('Each time you turn your HeadQ on, it calibrates/ reads your starting point. With the app you choose your preferred settings and range. The app is not needed for the HeadQ to work - only to change settings,<br><br>and to follow up on the statistics of your improvements'),
        imageUrl: require('@/assets/app.jpg'),
        rightAlign: true,
        scrollImage: true,
        leftAlignImage: true,
        appLink: true,
        type: 'fixed-image'
      }, {
        type: 'customer-quote',
        quote: this.__('When you correct your heads position the rest of the body follows.'),
        name: this.__('Liza, professional trainer')
      }, {
        title: this.__('Built on science, <br>tested by the pros'),
        copy: this.__('Several years of research and iterative development has resulted in a unique product.<br><br>The first wearable dedicated to horse-back riders.<br><br>More than 200 riders in four countries have tested, given feedback and helped us develop it to optimize its use and functionality.<br><br>84.6% of them would recommend it to their friends.'),
        imageUrl: require('@/assets/horseDuo.jpg'),
        type: 'fixed-image'
      }, {
        type: 'customer-quote',
        quote: this.__('This should be mandatory on every riding helmet.'),
        name: this.__('Sandra Wikström, instructor Realgymnasiet (School that teaches riding instructors)')
      }, {
        title: this.__('Designed for everyday use'),
        copy: this.__('It is hard to make something easy to use. We have.<br><br>You will learn how to in 2 minutes. <br><br>Durable design, dirt and water resistant.<br><br>Charged by inductive charging/ OI-charging?<br><br>A fully charged battery will last several hours'),
        imageUrl: require('@/assets/horseDark.jpg'),
        lightText: true,
        type: 'fixed-image'
      }, {
        type: 'customer-quote',
        quote: this.__('Looking up works and makes a difference. My horse has never performed better.'),
        name: this.__('Margareta Häggkvist')
      }, {
        title: this.__('Follow us!'),
        copy: this.__('Join us for the ride!<br>Know the latest news first.<br><br>Join our mailing list and we will keep you updated with news, tips and offers.'),
        imageUrl: require('@/assets/horseLight.jpg'),
        signup: true,
        type: 'fixed-image'
      }, {
        type: 'customer-quote',
        quote: this.__('One of the best inventions in the equine industry. That is my opinion anyway.'),
        name: this.__('Åsa Jensen Håkanson, owner Milåsa stables')
      }]
    }
  }
}
</script>
<style scoped lang="less">
  @import '../style/variables.less';

  .landingPageWrapper {
    position: relative;
    width: 100%;
    height: auto;
    padding-top: 50px;

    @media (max-width: 500px) {
      padding-top: 40px;
    }
  }
</style>
